export enum ModalMode {
  ADD = 'add',
  EDIT = 'edit',
  VIEW = 'view',
}

export enum ModalType {
  ARTIST = 'artist',
  ARTWORK = 'artwork',
}

export enum ArtworkCardType {
  MetaInfo = 'MetaInfo',
  StandardStock = 'StandardStock',
  ArtistProof = 'ArtistProof',
  UniquePiece = 'UniquePiece',
}

export enum ProductType {
  Artwork = 'Artwork',
  Residence = 'Residence',
  Frame = 'Frame',
}

export enum RefreshChannel {
  Inventory = 'Inventory',
  ProductVersion = 'ProductVersion',
}

export enum FrameOption {
  CustomFrame = 'CustomFrame',
  CustomPassepartout = 'CustomPassepartout',
}
